<div class="page-container">
  <div>
    <h1>Error</h1>
    <span>It looks like an error has occurred!</span>
  </div>
  <div>
    <button mat-stroked-button color="primary" routerLink="/">Back to Home</button>
  </div>
</div>

